import * as React from 'react';
import {Modal} from "reactstrap";
import ModalBody from "reactstrap/lib/ModalBody";
import ModalFooter from "reactstrap/lib/ModalFooter";
import ModalHeader from "reactstrap/lib/ModalHeader";
import {resourcesHelper} from "@falcon/services";

interface IProps {
    isOpen: boolean;
    onModalHide: () => void;
    id: string;
    title: string;
    body: React.ReactNode;
}

export class WarningModal extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
    }

    public render(): React.ReactNode {
        return (
            <Modal className="my-2 info-modal" isOpen={this.props.isOpen} toggle={this.props.onModalHide}>
                <ModalHeader toggle={this.props.onModalHide}>
                    <div className="d-flex">
                        <img src={`/${resourcesHelper.THEME}/img/alert-blue.svg`} alt="warning-sign"/>
                        <span className="ml-3 text-blue-2 fs-20 font-weight-medium"
                              id={this.props.id}>{this.props.title}</span>
                    </div>
                </ModalHeader>
                <ModalBody className="pt-0">
                    {this.props.body}
                </ModalBody>
                <ModalFooter className="d-flex">
                    <button type="button" className="btn btn-primary btn-add width-md-250 mb-1 btn-next-arrow-separate"
                            onClick={this.props.onModalHide}>Ok, I understand
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modals/WarningModal.tsx